go-card-row {
  --card-row-gap: 1rem;

  align-items: stretch;

  --go-col-gap: var(--card-row-gap);
  &.no-stretch {
    align-items: flex-start;
  }

  go-card {
    opacity: 0;
    max-height: 200px;
    &.loaded {
      opacity: 1;
      max-height: inherit;
    }
  }
  .stagger {
    go-card.loaded {
      opacity: 0;
    }
  }

  .card-col {
    margin-bottom: var(--card-row-gap);
  }
}
